import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components";
import ObjectOverride from "components/ObjectOverride";

export default class Custom880Buyer extends ObjectOverride {
	constructor(props) {
		super(props, Types.Custom_Modules_Customs_880._name);
		this.read = 'GET_BUYERS';
		this.update = this.props.id ? 'POST_BUYERS' : 'PUT_BUYERS';
		this.delete = 'DELETE_BUYERS';
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name);
		}
	}

	form = () => {
		let properties = this.model.properties;
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>

						<div className={"col-md"}>
							<h4 className="section-title">Product Buyer</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Name"}
									value={object.name}
									error={object.name_error}
									property={properties.name}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

						</div>

					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
